import VueRouter from "vue-router";
import Index from "./views/Index";
import Dashboard from "./views/Dashboard";
import Unit from "./views/Unit";
import UnitDetail from "./views/UnitDetails";
import Summary from "./views/Summary";
import Qualification from "./views/Qualification";
import QualificationDetail from "./views/QualificationDetails";
import Course from "./views/Course";
import Centre from "./views/Centre";
import CentreDetail from "./views/CentreDetails";
import Login from "./views/Login";
import Admin from "./views/Admin";
import Certification from "./views/Certification";
import Learner from "./views/Learner";
import LearnerDetail from "./views/LearnerDetails";
import AoDetail from "./views/AoDetails";
import Profile from "./views/Profile";
import PendingUnitDetail from "./views/PendingUnitDetails";
import PendingQualificationDetail from "./views/PendingQualificationDetails";
import PendingLearnerDetail from "./views/PendingLearnerDetails";
import PendingCertificationDetail from "./views/PendingCertificationDetails";
import PendingCentreDetail from "./views/PendingCentreDetails";
import Document from "./views/Document";
import PasswordReset from "./views/PasswordReset";
import CentreSignUp from "./views/CentreSignUp";

import store from "./store.js";

const router = new VueRouter({
  mode: "history",
  base: __dirname,
  routes: [
    { path: "/login", name: "Login", component: Login },
    {
      path: "/password-reset",
      name: "PasswordReset",
      component: PasswordReset
    },
    { path: "/signup/centre", name: "CentreSignUp", component: CentreSignUp },
    {
      path: "/",
      name: "Index",
      component: Index,
      children: [
        { path: "/", name: "Dashboard", component: Dashboard },
        { path: "units", name: "Units", component: Unit, props: true },
        {
          path: "units/details",
          name: "UnitDetails",
          component: UnitDetail,
          props: true
        },
        { path: ":section/summary", name: "Summary", component: Summary },
        {
          path: "qualifications",
          name: "Qualifications",
          component: Qualification,
          props: true
        },
        {
          path: "qualifications/details",
          name: "QualificationDetails",
          component: QualificationDetail,
          props: true
        },
        {
          path: "courses",
          name: "Courses",
          component: Course
        },
        { path: "centres", name: "Centres", component: Centre },
        {
          path: "centres/details",
          name: "CentreDetails",
          component: CentreDetail,
          props: true
        },
        { path: "admins", name: "Admins", component: Admin },
        {
          path: "certifications",
          name: "Certifications",
          component: Certification
        },
        { path: "learners", name: "Learners", component: Learner },
        {
          path: "learners/details",
          name: "LearnerDetails",
          component: LearnerDetail,
          props: true
        },
        {
          path: "ao/details",
          name: "AoDetails",
          component: AoDetail,
          props: true
        },
        { path: "profile", name: "Profile", component: Profile },
        {
          path: "pending-units/details",
          name: "PendingUnitDetails",
          component: PendingUnitDetail
        },
        {
          path: "pending-qualifications/details",
          name: "PendingQualificationDetails",
          component: PendingQualificationDetail
        },
        {
          path: "pending-learners/details",
          name: "PendingLearnerDetails",
          component: PendingLearnerDetail
        },
        {
          path: "pending-certifications/details",
          name: "PendingCertificationDetails",
          component: PendingCertificationDetail
        },
        {
          path: "pending-centres/details",
          name: "PendingCentreDetails",
          component: PendingCentreDetail
        },
        { path: "/documents", name: "Documents", component: Document }
      ]
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

// routes guard
router.beforeEach(async (to, from, next) => {
  const token = store.state.jwt;
  const role = store.state.role;

  // allow Password reset route to anyone
  if (to.name == "PasswordReset" || to.name == "CentreSignUp") {
    next();
    return;
  }

  if (to.name != "Login") {
    // check if both jwt and role exists in vuex storage before allowing route access
    if (!token || !role) {
      next({ name: "Login" });
    } else {
      const response = await fetch(
        `${process.env.VUE_APP_ROOT_API}/auth/checkExpiry`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const data = await response.json();

      if (data.status == "expired") {
        next({ name: "Login" });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
